module.exports = __webpack_public_path__ + "static/media/footer-img.41c51ea7.svg";